import React from "react"

import {RadioOptionRow, RadioIconContainer, RadioIcon, RadioOptionText} from "./styled"
import {OptionRow} from "../Radio"

const defaultRenderer = (optionRow: OptionRow) => {
  const {
    checked,
    option: {label}
  } = optionRow
  return (
    <RadioOptionRow defaultRenderer>
      <RadioIconContainer>
        <RadioIcon checked={checked} />
      </RadioIconContainer>
      <RadioOptionText flush>{label}</RadioOptionText>
    </RadioOptionRow>
  )
}

export default defaultRenderer
